import styled from '@emotion/styled';

import breakpoints from 'app/styles/constants/breakpoints';
import { endDirection, startDirection } from 'app/styles/selectors/markup';

const { widthSmall, widthMedium, widthLarge } = breakpoints;

const HeroBlock = styled.section`
  label: HeroBlock;

  display: flex;
  position: relative;
  flex-direction: column;

  @media (${widthSmall}) {
    align-items: center;
  }

  @media (${widthLarge}) {
    flex-direction: row;
    align-items: flex-start;
    justify-content: space-between;
  }
`;

const BackgroundDiv = styled.div`
  position: absolute;
  z-index: -1;
  width: 100%;
  height: 97%;
  background-color: var(--colors-black);

  @media (${widthSmall}) {
    height: 96%;
  }

  @media (${widthMedium}) {
    height: 95%;
  }
`;

const Content = styled.div`
  label: Content;

  display: flex;
  flex-direction: column;
  text-align: center;
  align-items: center;
  margin: 6.5rem 1.25rem 0rem;

  @media (${widthSmall}) {
    margin-${startDirection}: 5.25rem;
    margin-${endDirection}: 5.25rem;

  }

  @media (${widthLarge}) {
    text-align: ${startDirection};
    align-items: ${startDirection};
    margin-top: 7rem;
    margin-${startDirection}: 2.5rem;
    margin-${endDirection}: 3rem;
  }
`;

const Title = styled.h1`
  label: Title;

  color: var(--colors-white);
`;

const Subtitle = styled.h2`
  label: Subtitle;

  margin-top: 0.75rem;
  margin-bottom: 1.5rem;
  color: var(--colors-silver);

  @media (${widthSmall}) {
    margin-top: 2rem;
    margin-bottom: 0.75rem;
  }

  @media (${widthMedium}) {
    margin-top: 1.5rem;
    margin-bottom: 1.5rem;
    width: auto;
  }

  @media (${widthLarge}) {
    align-self: self-start;
  }
`;

const Description = styled.p`
  label: Description;

  margin-top: 1.5rem;
  color: var(--colors-silver-chalice);

  @media (${widthLarge}) {
    align-self: self-start;
  }
`;

const Subscribe = styled.a`
  label: SubscribeButton;

  @media (${widthLarge}) {
    align-self: self-start;
  }
`;

const StarsImage = styled.img`
  label: StarsImage;

  display: none;

  @media (${widthLarge}) {
    display: block;
    margin-${startDirection}: 1rem;
    margin-top: 1.875rem;
  }
`;

const HimeImage = styled.img`
  label: HimeImage;

  margin-${startDirection}: 1.75rem;
  margin-${endDirection}: 0.5rem;

  @media (${widthSmall}) {
    width: 28.875rem;
    height: 22.25rem;
    margin-top: 0.875rem;
    margin-${startDirection}: 0;
    margin-${endDirection}: 0;
  }

  @media (${widthMedium}) {
    width: auto;
    height: auto;
    margin-top: 3.75rem;
    margin-${startDirection}: 1.25rem;
    margin-${endDirection}: 5rem;
  }
`;

const Styled = {
  HeroBlock,
  BackgroundDiv,
  Content,
  Title,
  Subtitle,
  Description,
  Subscribe,
  StarsImage,
  HimeImage,
};

export default Styled;
